import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { logo, mobileBtn, mobileLogo } from '../../../../../images/index.js'
import { getBrandName } from "../../Components/getBrandName";
import { NavLink } from "react-router-dom";
const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const { normalizedBrand, brandName, isGapalyzeDomain } = getBrandName();
  const [imgError, setImgError] = useState(false);

  // ✅ Fixed scroll direction logic
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // 🧭 Scrolling DOWN → Hide navbar
        setShowNavbar(false);
      } else {
        // 🧭 Scrolling UP → Show navbar
        setShowNavbar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    document.querySelectorAll('.dropdown-toggle').forEach(dropdownToggleEl => {
      new Dropdown(dropdownToggleEl);
    });

    // document.body.classList.toggle('dark-theme', theme === 'dark');
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem('theme', theme);

    // listen to custom event in globaly
    window.dispatchEvent(new Event('themeChanged'));
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  return (
    <nav className={`navbar navbar-expand-lg new-navbar ${showNavbar ? "navbar-visible" : "navbar-hidden"
      }`}>
      <div className="container-fluid custom-nav">
        <Link to="/" className="logo gapalyze-logo d-flex align-items-center">
          {!imgError && isGapalyzeDomain ? (
            <img
              src={isGapalyzeDomain ? logo : logo}

              alt={isGapalyzeDomain ? "Gapalyze" : "Marketplace Throughout"}
              className="logo-header-image"
              style={{
                height: "auto",
                objectFit: "contain",
                transition: "all 0.3s ease",
                width: "200px"
              }}
              onError={() => setImgError(true)} // 👈 when image fails, switch to <h1>
            />
          ) : (
            <h5
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: "#333",
                margin: 0,
              }}
            >
              {/* {isGapalyzeDomain ? "Gapalyze" : "MPThroughout"} */}
              <img
                src={isGapalyzeDomain ? logo : logo}
                alt={isGapalyzeDomain ? "Gapalyze" : "Marketplace Throughout"}
                className="logo-header-image"
                style={{
                  height: "auto",
                  objectFit: "contain",
                  transition: "all 0.3s ease",
                  width: "200px"
                }}
                onError={() => setImgError(true)} // 👈 when image fails, switch to <h1>
              />
              <img
                src={isGapalyzeDomain ? logo : mobileLogo}
                alt={isGapalyzeDomain ? "Gapalyze" : "Marketplace Throughout"}
                className="logo-header-image-mobile"
                style={{
                  height: "35px",
                  objectFit: "contain",
                  transition: "all 0.3s ease",
                }}
                onError={() => setImgError(true)} // 👈 when image fails, switch to <h1>
              />


            </h5>
          )}
        </Link>
        <div className={`d-flex gap-1 nav-icon${isOpen} me-1`}>
          <img src={mobileBtn} className="img-fluid navbar-toggler border-0" alt="mobileBtn" onClick={() => setIsOpen(!isOpen)}></img>
        </div>

        <div className={`collapse navbar-collapse justify-content-center ${isOpen ? "show" : ""}`}>
          <ul className="navbar-nav  mb-2 mb-lg-0 d-flex align-items-lg-center gap-3">
            {/* <li className="nav-item">
              <Link className="nav-link" to={"/"}>
                Home
              </Link>
            </li> */}
            <li className="nav-item">
              <NavLink className="nav-link" to="/about-us">
                About Us
              </NavLink>
              {/* <Link className="nav-link" to={"/about-us"}>
                About Us
              </Link> */}
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/pricing">
                Pricing
              </NavLink>
              {/* <Link className="nav-link" to={"/pricing"}>
                Pricing
              </Link> */}
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/blog">
                Blog
              </NavLink>
              {/* <Link className="nav-link" to={"/blog"}>
                Blog
              </Link> */}
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/faq">
                FAQs
              </NavLink>
              {/* <Link className="nav-link" to={"/faq"}>
                FAQs
              </Link> */}
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/contact">
                Contact Us
              </NavLink>
              {/* <Link className="nav-link" to={"/contact"}>
                Contact Us
              </Link> */}
            </li>
            <li className="nav-item sign-auth-hidden">
              <Link className="nav-link" to={"/signin"}>
                SignUp/SignIn
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link className="btn navbar-btn auth-btn" type="button" to={"/signin"}>
                SignUp/SignIn
              </Link>
            </li> */}
            {/* <li className="nav-item dropdown pe-2 web-theme-icon" onClick={toggleTheme} style={{ cursor: "pointer" }}>
              {theme === 'dark' ? (
                <i
                  className="bi bi-sun bg-light theme-icon rounded-circle d-flex justify-content-center align-items-center"
                  style={{
                    fontSize: '1.2rem',
                    width: '40px',
                    height: '40px',
                  }}
                ></i>) : (
                <i
                  className="bi bi-moon-stars bg-light theme-icon rounded-circle d-flex justify-content-center align-items-center"
                  style={{
                    fontSize: '1.5rem',
                    width: '40px',
                    height: '40px',
                  }}
                ></i>)}
            </li> */}
          </ul>
        </div>

        <div>
          <Link className="btn navbar-btn sign-auth-btn" type="button" to={"/signin"}>
            Get Started
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Header;
